var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: ["result", "container", _vm.loading ? "loadingResults" : ""],
      on: { scroll: _vm.onScroll },
    },
    [
      _c("div", { staticClass: "tabs" }, [
        _c(
          "div",
          {
            class: ["tab-button", { active: _vm.activeView === "products" }],
            on: {
              click: function ($event) {
                _vm.activeView = "products"
              },
            },
          },
          [
            _vm._v(" " + _vm._s(this.$root.language.wsm_CO_products) + " "),
            _c("span", { staticClass: "resultCount" }, [
              _vm._v(_vm._s(_vm.result.products.length)),
            ]),
          ]
        ),
        _c(
          "div",
          {
            class: ["tab-button", { active: _vm.activeView === "articles" }],
            on: {
              click: function ($event) {
                _vm.activeView = "articles"
              },
            },
          },
          [
            _vm._v(" " + _vm._s(this.$root.language.wsm_relatedArticles) + " "),
            _c("span", { staticClass: "resultCount" }, [
              _vm._v(_vm._s(_vm.result.articles.length)),
            ]),
          ]
        ),
        _c(
          "div",
          {
            class: ["tab-button", { active: _vm.activeView === "videos" }],
            on: {
              click: function ($event) {
                _vm.activeView = "videos"
              },
            },
          },
          [
            _vm._v(" " + _vm._s(this.$root.language.wsm_videos) + " "),
            _c("span", { staticClass: "resultCount" }, [
              _vm._v(_vm._s(_vm.result.videos.length)),
            ]),
          ]
        ),
      ]),
      _c("div", [
        _vm.result.products.length > 0 && _vm.activeView == "products"
          ? _c("div", { staticClass: "products" }, [
              _c(
                "div",
                _vm._l(_vm.result.products, function (productInfo) {
                  return _c(
                    "a",
                    {
                      key: productInfo.sortNo,
                      attrs: {
                        href:
                          _vm.basedir +
                          "/" +
                          (_vm.$root.pointshop
                            ? _vm.$root.pointshopprefix
                            : "") +
                          productInfo.productPageLink,
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          key: productInfo.sortNo,
                          staticClass: "prodContainer",
                        },
                        [
                          _c("div", { staticClass: "prodImg" }, [
                            _c("img", {
                              attrs: {
                                src: `${_vm.fetchImageUrl(
                                  productInfo.imageUrl,
                                  productInfo.sku_no,
                                  productInfo.name
                                )}?w=10&quality=1`,
                                srcset: _vm.imageSet(
                                  _vm.fetchImageUrl(
                                    productInfo.imageUrl,
                                    productInfo.sku_no,
                                    productInfo.name
                                  )
                                ).set,
                              },
                            }),
                          ]),
                          _c("div", { staticClass: "prodInfo" }, [
                            _c("div", { staticClass: "prodHeader" }, [
                              _c("h5", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.truncateString(productInfo.name, 50)
                                  ),
                                },
                              }),
                              Array.isArray(productInfo.promotionAttributes) &&
                              productInfo.promotionAttributes.length &&
                              !_vm.$root.noshop
                                ? _c("span", { staticClass: "promo" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          productInfo.promotionAttributes[0]
                                            .name
                                        ) +
                                        " "
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                            _c("div", {
                              staticClass: "quantString",
                              domProps: {
                                innerHTML: _vm._s(productInfo.quantityString),
                              },
                            }),
                            _c("p", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.truncateString(
                                    (productInfo.description || "").replace(
                                      "<br>",
                                      ""
                                    ),
                                    100
                                  )
                                ),
                              },
                            }),
                            _vm.$root.isWebshop &&
                            !_vm.$root.noshop &&
                            !_vm.$root.onlybuywhenloggedin
                              ? _c("p", {
                                  staticClass: "price",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.getPrice(
                                        productInfo.price,
                                        productInfo.CurrencyIso,
                                        productInfo.currencyPrecision,
                                        productInfo.locale
                                      )
                                    ),
                                  },
                                })
                              : _vm._e(),
                            _vm.$root.isWebshop &&
                            !_vm.$root.noshop &&
                            !_vm.$root.onlybuywhenloggedin
                              ? _c("div", { staticClass: "additionalInfo" }, [
                                  productInfo.discount > 0
                                    ? _c("p", [
                                        _c("span", {
                                          staticClass: "strikedPrice",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.getPrice(
                                                productInfo.listPrice,
                                                productInfo.CurrencyIso,
                                                productInfo.currencyPrecision,
                                                productInfo.locale
                                              )
                                            ),
                                          },
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$root.language.wsm_YouSave
                                            ) +
                                            " "
                                        ),
                                        _c("span", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.getPrice(
                                                productInfo.discount,
                                                productInfo.CurrencyIso,
                                                productInfo.currencyPrecision,
                                                productInfo.locale
                                              )
                                            ),
                                          },
                                        }),
                                      ])
                                    : _vm._e(),
                                  _vm.$root.iscompany &&
                                  productInfo.taxRateFactor > 1
                                    ? _c("p", { staticClass: "inclVat" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$root.language.wsm_InclVAT
                                          ) +
                                            " " +
                                            _vm._s(
                                              _vm.getPrice(
                                                productInfo.companyPriceIncludingVat,
                                                productInfo.CurrencyIso,
                                                productInfo.currencyPrecision,
                                                productInfo.locale
                                              )
                                            )
                                        ),
                                      ])
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      ),
                    ]
                  )
                }),
                0
              ),
            ])
          : _vm._e(),
        _vm.result.products.length == 0 && _vm.activeView == "products"
          ? _c("div", [
              _c("p", { staticClass: "noResult" }, [
                _vm._v(_vm._s(this.$root.language.wsm_noResult)),
              ]),
            ])
          : _vm._e(),
        _vm.result.articles.length > 0 && _vm.activeView == "articles"
          ? _c(
              "div",
              { staticClass: "articles" },
              _vm._l(_vm.result.articles, function (article, index) {
                return _c(
                  "a",
                  {
                    key: index,
                    staticClass: "articlesWrapper",
                    attrs: {
                      href: _vm.basedir + article.urlPrefix + article.url,
                    },
                  },
                  [
                    _c("div", { staticClass: "articleContainer" }, [
                      _c("img", {
                        attrs: {
                          src:
                            article.imageUrl.indexOf("http") >= 0
                              ? article.imageUrl
                              : _vm.basedir + article.imageUrl,
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "articleInfo" }, [
                        _c("h5", [
                          _vm._v(
                            _vm._s(_vm.truncateString(article.headers, 40))
                          ),
                        ]),
                        _c("p", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.truncateString(article.description, 100)
                            ),
                          },
                        }),
                      ]),
                    ]),
                  ]
                )
              }),
              0
            )
          : _vm._e(),
        _vm.result.articles.length == 0 && _vm.activeView == "articles"
          ? _c("div", [
              _c("p", { staticClass: "noResult" }, [
                _vm._v(_vm._s(this.$root.language.wsm_noResult)),
              ]),
            ])
          : _vm._e(),
        _vm.result.videos.length > 0 && _vm.activeView == "videos"
          ? _c(
              "div",
              { staticClass: "videos" },
              _vm._l(_vm.result.videos, function (video, index) {
                return _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.show,
                        expression: "show",
                      },
                    ],
                    key: index,
                    staticClass: "videoSlide",
                    on: {
                      click: function ($event) {
                        _vm.$refs["ytplayer_" + video.id][0].openVideo(
                          "",
                          video.id
                        )
                      },
                    },
                  },
                  [
                    _c("video-container", {
                      attrs: {
                        useLazy: false,
                        index: index,
                        video: video,
                        numberOfCharacters: 40,
                      },
                    }),
                  ],
                  1
                )
              }),
              0
            )
          : _vm._e(),
        _vm.result.videos.length == 0 && _vm.activeView == "videos"
          ? _c("div", [
              _c("p", { staticClass: "noResult" }, [
                _vm._v(_vm._s(this.$root.language.wsm_noResult)),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm._l(_vm.result.videos, function (video, index) {
        return _c(
          "div",
          { key: index },
          [
            _c("youtubeplayer3", {
              key: index,
              ref: "ytplayer_" + video.id,
              refInFor: true,
              attrs: {
                videoData: video,
                videoDataStatus: true,
                playListArray: [],
              },
            }),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }